// cohorts/create types: Zod schemas are the contract, parsed at the service boundary.
// Request shape of `POST /cohorts/` (cohorts-v1.md).
import { z } from "zod";

/**
 * What the person types in the « Nouvelle cohorte » form. Messages are i18n keys in the `cohorts`
 * namespace. A cleared number field gives `NaN`, which fails as « required » rather than passing as
 * a number. The end must follow the start (the API says the same).
 */
export const CreateCohortFormSchema = z
  .object({
    name: z.string().trim().min(1, "create.errors.name-required"),
    places: z
      .number("create.errors.places-invalid")
      .int("create.errors.places-invalid")
      .min(1, "create.errors.places-invalid"),
    waitlistPlaces: z
      .number("create.errors.waitlist-invalid")
      .int("create.errors.waitlist-invalid")
      .min(0, "create.errors.waitlist-invalid"),
    /** ISO dates (`2027-01-03`), or `""` while nothing valid is typed. */
    startDate: z.string().min(1, "create.errors.start-required"),
    endDate: z.string().min(1, "create.errors.end-required"),
    administratorId: z.string().min(1, "create.errors.administrator-required"),
  })
  .refine(
    (value) =>
      !value.startDate || !value.endDate || value.endDate > value.startDate,
    {
      path: ["endDate"],
      message: "create.errors.end-before-start",
    }
  );

export type CreateCohortFormValues = z.infer<typeof CreateCohortFormSchema>;

/** The active Administrators the President can choose from. */
export const AdministratorOptionSchema = z.object({
  id: z.string(),
  display_name: z.string(),
  email: z.string(),
  role: z.string(),
  account_status: z.string(),
});

export type AdministratorOption = z.infer<typeof AdministratorOptionSchema>;

export const AdministratorOptionsSchema = z.object({
  members: z.array(AdministratorOptionSchema),
});
